// extracted by mini-css-extract-plugin
export default {"adregion":"index_adregion_p50lH"};